import React from "react";
import LineChart from "../../charts/LineChart03";
import RiskOverTimeChart from "../../charts/RiskOverTimeChart";

// Import utilities
import { tailwindConfig, hexToRGB } from "../../utils/Utils";

function AnalyticsCard01(props) {
  const data = props.data;
  const loading = props.loading;
  const title = props.title;
  const score = props.score;
  const burden = props.burden;
  const effort = props.effort;
  const breakEven = props.breakEven;
  const burdenSummary = props.burdenSummary;
  const resolved = props.resolved;
  const remaining = props.remaining;
  const impediments = props.impediments;

  const chartData = {
    labels: props.labels,
    datasets: [
      // Indigo line
      {
        label: "Current",
        data: props.values,
        fill: true,
        backgroundColor: `rgba(${hexToRGB(
          tailwindConfig().theme.colors.accent[300]
        )}, 0.08)`,
        borderColor: tailwindConfig().theme.colors.accent[500],
        borderWidth: 2,
        tension: 0,
        pointRadius: 0,
        pointHoverRadius: 3,
        pointBackgroundColor: tailwindConfig().theme.colors.accent[700],
      },
      // Gray line
      // {
      //   label: "Previous",
      //   data: [
      //     8000, 5000, 6500, 5000, 6500, 12000, 8000, 9000, 8000, 8000, 12500,
      //     10000, 10000, 12000, 11000, 16000, 12000, 10000, 10000, 14000, 9000,
      //     10000, 15000, 12500, 14000, 11000,
      //   ],
      //   borderColor: tailwindConfig().theme.colors.gray[300],
      //   fill: false,
      //   borderWidth: 2,
      //   tension: 0,
      //   pointRadius: 0,
      //   pointHoverRadius: 3,
      //   pointBackgroundColor: tailwindConfig().theme.colors.gray[300],
      // },
    ],
  };

  return (
    <div className="flex flex-col col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
      <header className="px-5 py-4 border-b border-gray-100 flex items-center">
        <h2 className="font-semibold text-slate-800">Burden Overview</h2>
      </header>
      <div className="px-5 py-1">
        <div className="flex flex-wrap">
          {/* Unique Visitors */}
          <div className="flex items-center py-2">
            <div className="mr-5">
              <div className=" text-sm font-semibold text-slate-500 uppercase mb-1">
                {"Impediments"}
              </div>
              <div className="flex items-center">
                <div className="text-3xl font-bold text-slate-800 mr-2">
                  {impediments}
                </div>
                {/* <div className="text-sm font-medium text-green-500">+49%</div> */}
              </div>
              <div className="text-sm text-slate-500">total</div>
            </div>
            <div
              className="hidden md:block w-px h-8 bg-gray-200 mr-5"
              aria-hidden="true"
            ></div>
          </div>
          {/* Unique Visitors */}
          <div className="flex items-center py-2">
            <div className="mr-5">
              <div className=" text-sm font-semibold text-slate-500 uppercase mb-1">
                {"Burden"}
              </div>
              <div className="flex items-center">
                <div className="text-3xl font-bold text-slate-800 mr-2">
                  {score}
                </div>
                {/* <div className="text-sm font-medium text-green-500">+49%</div> */}
              </div>
              <div className="text-sm text-slate-500">hours/wk</div>
            </div>
            <div
              className="hidden md:block w-px h-8 bg-gray-200 mr-5"
              aria-hidden="true"
            ></div>
          </div>
          {/* Total Pageviews */}
          <div className="flex items-center py-2">
            <div className="mr-5">
              <div className=" text-sm font-semibold text-slate-500 uppercase mb-1">
                {"Effort"}
              </div>
              <div className="flex items-center">
                <div className="text-3xl font-bold text-slate-800 mr-2">
                  {effort}
                </div>
                {/* <div className="text-sm font-medium text-green-500">+7%</div> */}
              </div>
              <div className="text-sm text-slate-500">days</div>
            </div>
            <div
              className="hidden md:block w-px h-8 bg-gray-200 mr-5"
              aria-hidden="true"
            ></div>
          </div>

          <div className="flex items-center py-2">
            <div className="mr-5">
              <div className=" text-sm font-semibold text-slate-500 uppercase mb-1">
                {"Potential Savings"}
              </div>
              <div className="flex items-center">
                <div className="text-3xl font-bold text-slate-800 mr-2">
                  {burdenSummary["First year savings"] > 0
                    ? burdenSummary["First year savings"].toFixed(0)
                    : 0}
                </div>
                {/* <div className="text-sm font-medium text-green-500">+7%</div> */}
              </div>
              <div className="text-sm text-slate-500">days/yr</div>
            </div>
            <div
              className="hidden md:block w-px h-8 bg-gray-200 mr-5"
              aria-hidden="true"
            ></div>
          </div>
          {/* Remaining */}
          <div className="flex items-center py-2">
            <div className="mr-5">
              <div className=" text-sm font-semibold text-slate-500 uppercase mb-1">
                {"Burden Resolved"}
              </div>
              <div className="flex items-center">
                <div className="text-3xl font-bold text-slate-800 mr-2">
                  {resolved}
                </div>
                {/* <div className="text-sm font-medium text-green-500">+7%</div> */}
              </div>
              <div className="text-sm text-slate-500">hours/wk</div>
            </div>
            <div
              className="hidden md:block w-px h-8 bg-gray-200 mr-5"
              aria-hidden="true"
            ></div>
          </div>

          {/* Visit Duration*/}
          <div className="flex items-center">
            <div>
              <div className=" text-sm font-semibold text-slate-500 uppercase mb-1">
                {"Burden Remaining"}
              </div>
              <div className="flex items-center">
                <div className="text-3xl font-bold text-slate-800 mr-2">
                  {remaining}
                </div>
                {/* <div className="text-sm font-medium text-yellow-500">+7%</div> */}
              </div>
              <div className="text-sm text-slate-500">hours/wk</div>
            </div>
          </div>
          {/* remaining */}
        </div>
      </div>
      {/* Chart built with Chart.js 3 */}
      <div className="grow">
        {/* Change the height attribute to adjust the chart height */}
        {/* <LineChart data={chartData} width={800} height={300} /> */}
        <RiskOverTimeChart data={chartData} width={800} height={300} />
      </div>
    </div>
  );
}

export default AnalyticsCard01;
